import React, { useEffect, useState } from "react";
import client from "../../lib/api";
import { AlertTriangle, Sparkles, Gift, MessageSquareQuote } from "lucide-react";
import { Panel } from "../ui-kit";
import { ZoneBadge, ScoreBars, ZONE, metricLabel } from "../workforce/shared";

export function MyZone() {
  const [d, setD] = useState(null);
  useEffect(() => { client.get("/tm/workforce").then(({ data }) => setD(data)).catch(() => {}); }, []);
  if (!d) return null;
  const s = d.latest;
  return (
    <Panel title="Mera Zone & Score" testid="tm-zone" right={<ZoneBadge zone={s?.zone} testid="tm-zone-badge" />}>
      <div className="p-4 space-y-4">
        {!s ? <p className="text-sm text-slate-400">Aapka pehla score aaj raat 9:30 baje banega.</p> : (
          <>
            <div className="flex items-center gap-4">
              <div className={`font-mono text-5xl ${ZONE[s.zone]?.cls.split(" ")[0] || "text-white"}`} data-testid="tm-score">{s.score ?? "—"}</div>
              <div className="flex-1"><ScoreBars parts={s.metrics?.parts} /></div>
            </div>
            {d.paused_until && <div className="text-xs text-bear">⛔ Nayi leads {new Date(d.paused_until).toLocaleDateString()} tak suspend hain.</div>}
            {s.issues?.length > 0 && (
              <div><div className="text-[10px] uppercase tracking-widest text-slate-500 mb-1.5">Kami kaha hai</div>
                <ul className="space-y-1" data-testid="tm-issues">{s.issues.map((i) => <li key={i} className="text-xs text-slate-300 flex gap-1.5"><AlertTriangle size={13} className="text-bear shrink-0 mt-0.5" />{i}</li>)}</ul></div>
            )}
            {s.ai_tips && <div className="bg-white/[0.03] p-3" data-testid="tm-tips"><div className="text-[10px] uppercase tracking-widest text-gold mb-1 flex items-center gap-1"><Sparkles size={12} />Green zone me aane ke liye</div><div className="text-xs text-slate-300 whitespace-pre-line">{s.ai_tips}</div></div>}
            {s.admin_note && <div className="border-l-2 border-gold pl-3" data-testid="tm-admin-note"><div className="text-[10px] uppercase tracking-widest text-gold mb-1 flex items-center gap-1"><MessageSquareQuote size={12} />Admin review</div><div className="text-xs text-slate-200">{s.admin_note}</div></div>}
          </>
        )}
        {d.rewards.length > 0 && (
          <div data-testid="tm-rewards"><div className="text-[10px] uppercase tracking-widest text-slate-500 mb-1.5">Rewards</div>
            <div className="grid sm:grid-cols-2 gap-2">
              {d.rewards.map((r) => (
                <div key={r.title} className="border border-[color:var(--border-subtle)] p-3 text-xs">
                  <div className="text-white flex items-center gap-1.5"><Gift size={13} className="text-gold" />{r.title}</div>
                  <div className="text-slate-500 mt-0.5">{metricLabel[r.metric]} · {r.period} · 🎁 {r.prize}</div>
                  <div className="mt-1.5 text-slate-300">Aapka rank <b className="text-gold">#{r.rank ?? "—"}</b> / {r.of} · aap {r.value} · leader {r.leader_value}</div>
                </div>
              ))}
            </div>
          </div>
        )}
        {d.won.length > 0 && <div className="text-xs text-gold" data-testid="tm-won">🏆 Jeete: {d.won.map((w) => `${w.title} (${w.period_key})`).join(", ")}</div>}
      </div>
    </Panel>
  );
}
